"use client"
import React, { useRef } from "react"
import SectionHeader from "./SectionHeader"
import SectionSubheader from "./SectionSubheader"

export default function FeaturedPublicationsSection({
  children,
}: {
  children: React.ReactNode
}) {
  const sectionRef = useRef<HTMLDivElement>(null)

  return (
    <div ref={sectionRef} className=" bg-ivory py-24">
      <div className="container">
        <SectionHeader ref={sectionRef}>Ideas that matter</SectionHeader>
        <SectionSubheader ref={sectionRef}>
          Read the voices driving today's most important conversations.
        </SectionSubheader>
      </div>
      <div className="pt-8 sm:pt-12">{children}</div>
    </div>
  )
}
